import * as React from 'react'
import { AppMainView, AppView } from '../../../../components/AppView'
import AppHeader from '../../../../components/AppView/Header'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { CurrentUserStore } from '../../../../stores/CurrentUserStore'
import { inject, observer } from 'mobx-react'
import Helmet from 'react-helmet'
import './ParkedSales.scss'
import { ParkedSaleStore } from './ParkedSaleStore'
import AppPagination from '../../../../components/Pagination/index'
import { NoPermissionsResult } from '../../../../components/NoPermissionsResult'
import { Skeleton, Alert } from 'antd'
import { FilterGroup } from './FilterGroup'
import { ParkedSaleTable } from './ParkedSaleTable'
import { ParkedSaleAlert } from './ParkedSaleAlert'
import { ParkedSaleModal } from './ParkedSaleModal'
import { PermissionNames } from '@getgreenline/homi-shared'
import { ProductStore } from '../../../../stores/CurrentCompanyStore/ProductStore'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  currentUserStore?: CurrentUserStore
}

@inject('currentCompanyStore', 'currentUserStore')
@observer
export class ParkedSales extends React.Component<Props> {
  company = this.props.currentCompanyStore?.company
  store: CurrentCompanyStore | undefined = this.props.currentCompanyStore
  productStore: ProductStore | undefined = this.store?.productStore
  parkedSaleStore =
    this.store && this.productStore ? new ParkedSaleStore(this.store, this.productStore) : undefined

  render() {
    if (!this.company || !this.store || !this.productStore || !this.parkedSaleStore) {
      return null
    }

    const {
      loading,
      filter,
      offset,
      limit,
      total,
      searchPaymentQueues,
      alertPaymentQueues,
      isParkedSaleModalOpen,
      posListingLoading,
    } = this.parkedSaleStore
    const currentPage = Math.floor(offset / limit)
    const numberOfPages = Math.ceil(total / limit)

    if (
      !this.props.currentUserStore!.hasPermissionAtEntity(
        PermissionNames.CAN_MANAGE_PARKED_SALES,
        this.company.id,
      )
    ) {
      return <NoPermissionsResult permissionName={PermissionNames.CAN_MANAGE_PARKED_SALES} />
    }

    return (
      <AppView column>
        <Helmet>
          {this.props.currentCompanyStore?.canDisplayOnlineOrdersReceipts ? (
            <title>Sales | Order Hub</title>
          ) : (
            <title>Sales | Parked Sales</title>
          )}
          <meta name='page-loaded' content='true' />
        </Helmet>
        <AppHeader
          title={
            this.props.currentCompanyStore?.canDisplayOnlineOrdersReceipts
              ? 'Order hub'
              : 'Parked sales'
          }
        />
        <AppMainView className='background-grey intercom-pb-2'>
          <div className='white-rounded-container'>
            <FilterGroup parkedSaleStore={this.parkedSaleStore} />
            {!!this.parkedSaleStore.isDateLimitExceeded && (
              <div className='parked-sale-alerts'>
                <Alert
                  message={<strong>Please select a date range within 3 months</strong>}
                  type='error'
                  showIcon
                />
              </div>
            )}
            <div className='parked-sale-alerts' style={{ display: 'flex', flexWrap: 'wrap' }}>
              {Object.keys(alertPaymentQueues).map((alertQueueStatus) => {
                const alertPaymentQueue = alertPaymentQueues[alertQueueStatus]
                if (!this.parkedSaleStore) return null

                return (
                  alertPaymentQueue.length > 0 && (
                    <ParkedSaleAlert
                      key={`parkedSaleAlert${alertQueueStatus}`}
                      alertPaymentQueue={alertPaymentQueue}
                      parkedSaleType={alertQueueStatus}
                      parkedSaleStore={this.parkedSaleStore}
                    />
                  )
                )
              })}
            </div>
          </div>

          {!loading && !posListingLoading ? (
            <div className='white-rounded-container' style={{ padding: 0 }}>
              <ParkedSaleTable parkedSaleStore={this.parkedSaleStore} />
            </div>
          ) : (
            <Skeleton active />
          )}

          {isParkedSaleModalOpen && <ParkedSaleModal parkedSaleStore={this.parkedSaleStore} />}

          <AppPagination
            currentPage={currentPage}
            pageCount={numberOfPages}
            onPageChange={({ selected }: { selected: number }) => {
              filter.setOffset(selected * limit)
              searchPaymentQueues()
            }}
          />
        </AppMainView>
      </AppView>
    )
  }
}
